export default __webpack_public_path__ + "static/media/nosotros-6.81d50a66.jpg";